module.exports = __webpack_public_path__ + "db25c104dd6f1d5af7b2414c3b3d675b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-10.jpg
// module id = 84
// module chunks = 0